import {PrivateCommand} from "../PrivateCommand";
import {EventManager} from "../../event-manager";
import cmpStatus from "../../../cmp-status";
import {log} from "../../../util/log";
import {ConsentData} from "../../model/consent-data";

class AddEventListenerPrivateCommand extends PrivateCommand {

    public execute(option?: string, callback?: Function): void {
        let triggered:boolean = false;
        let sendConsentData: boolean = false;
        log.debug(`waiting for event ${option}...`)
        switch (option) {
            case EventManager.EVENT_CMP_READY:
                sendConsentData = true;
            case EventManager.EVENT_CMP_LOADED:
                if (cmpStatus.cmpLoaded) {
                    triggered = true;
                }
                break;
            case EventManager.EVENT_CMP_CONFIGURED:
                sendConsentData = true;
                if (cmpStatus.cmpConfigured) {
                    triggered = true;
                }
                break;
            case EventManager.EVENT_CHANGED_CONFIG:
                sendConsentData = true;
                break;
        }
        if (option && callback) {
            if (!triggered) {
                EventManager.registerEvent(option, callback);
            } else {
                const listenerId: number = EventManager.registerEvent(option, callback);

                if (sendConsentData) {
                    // Respondemos inmediatamente con lo que haya en el ConsentData
                    const consentData = ConsentData.build(listenerId);
                    callback(consentData, true);
                } else {
                    callback();
                }
            }
        }
    }

}

export {AddEventListenerPrivateCommand}
